export const updateUserApi = (BeURL, showAlert, user) => {
    fetch(`${BeURL}/update-user-profile`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fullName: user.fullName, contact: user.contact})
    })
        .then(res => res.json())
        .then(data => {
            showAlert(data.message)
        })
        .catch(err => {
            console.log('Error in Singup:', err)
            showAlert('Trouble in connecting to the Server! Please try again later.')
        })
}